import { MaticStakingApi } from './api.js'

// function selector for buyVoucher(uint256 _amount, uint256 _minSharesToMint)
const DELEGATE = '0x6ab15071'
// function selector for sellVoucher_new(uint256 claimAmount, uint256 maximumSharesToBurn)
const UNDELEGATE = '0xc83ec04d'
// function selector for withdrawRewards()
const CLAIM_REWARD = '0xc7b8981c'
// function selector for unstakeClaimTokens_new(uint256 unbondNonce)
const CLAIM_UNDELEGATE_BALANCE = '0xe97fddc2'

const STAKING_MANAGER_CONTRACT = MaticStakingApi.STAKING_MANAGER_ADDR

export const isPolygonTx = ({ coinName }) => coinName === 'polygon'
export const isPolygonDelegate = (tx) =>
  isPolygonTx(tx) && tx.to === STAKING_MANAGER_CONTRACT && tx.data?.methodId === DELEGATE
export const isPolygonUndelegate = (tx) =>
  isPolygonTx(tx) && tx.from[0] === STAKING_MANAGER_CONTRACT && tx.data?.methodId === UNDELEGATE
export const isPolygonReward = (tx) =>
  isPolygonTx(tx) && tx.from[0] === STAKING_MANAGER_CONTRACT && tx.data?.methodId === CLAIM_REWARD
export const isPolygonClaimUndelegate = (tx) =>
  isPolygonTx(tx) &&
  tx.from[0] === STAKING_MANAGER_CONTRACT &&
  tx.data?.methodId === CLAIM_UNDELEGATE_BALANCE
